import { IAge } from '../models/age.interface';

export const AGE_0_5: IAge = {
  title: '0-5 Years',
  tag: '0-5'
};

export const AGE_6_12: IAge = {
  title: '6-12 Years',
  tag: '6-12'
};

export const AGE_13_17: IAge = {
  title: '13-17 Years',
  tag: '13-17'
};

export const AGE_18_65: IAge = {
  title: '18-65 Years',
  tag: '18-65'
};

export const AGE_66_PLUS: IAge = {
  title: '66+ Years',
  tag: '66-150'
};

export const AGE_LIST: IAge[] = [
  AGE_0_5,
  AGE_6_12,
  AGE_13_17,
  AGE_18_65,
  AGE_66_PLUS
];
